class ReviewsSlider {
  constructor(container) {
    this.container = container;
    this.slides = container.querySelectorAll('.fcd-reviews-block__review');
    this.totalSlides = this.slides.length;
    this.currentIndex = 0;
    this.slidesToShow = 3;
    this.slidesToMove = 3;
    
    // Solo inicializar si hay más de 3 slides
    if (this.totalSlides <= this.slidesToShow) {
      return;
    }
    
    this.init();
  }
  
  init() {
    this.createSliderStructure();
    this.setupEventListeners();
    this.updateSlider();
    this.createPagination();
  }
  
  createSliderStructure() {
    // Crear contenedor del slider
    this.sliderContainer = document.createElement('div');
    this.sliderContainer.className = 'reviews-slider-container';
    
    // Crear track del slider
    this.sliderTrack = document.createElement('div');
    this.sliderTrack.className = 'reviews-slider-track';
    
    // Crear wrapper para los slides
    this.slidesWrapper = document.createElement('div');
    this.slidesWrapper.className = 'reviews-slides-wrapper';
    
    // Mover los slides al wrapper
    this.slides.forEach(slide => {
      slide.classList.add('reviews-slide');
      this.slidesWrapper.appendChild(slide);
    });
    
    // Construir estructura
    this.sliderTrack.appendChild(this.slidesWrapper);
    this.sliderContainer.appendChild(this.sliderTrack);
    
    // Reemplazar el contenido original
    this.container.innerHTML = '';
    this.container.appendChild(this.sliderContainer);
    
    // Re-obtener los slides después de moverlos
    this.slides = this.sliderContainer.querySelectorAll('.reviews-slide');
  }
  
  setupEventListeners() {
    // Touch events para mobile
    let startX = 0;
    let currentX = 0;
    let isDragging = false;
    
    this.sliderTrack.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
      this.sliderTrack.style.transition = 'none';
    });
    
    this.sliderTrack.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      currentX = e.touches[0].clientX;
      const diff = startX - currentX;
      this.sliderTrack.style.transform = `translateX(${-this.currentIndex * (100 / this.slidesToShow)}% - ${diff}px)`;
    });
    
    this.sliderTrack.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      this.sliderTrack.style.transition = 'transform 0.3s ease';
      
      const diff = startX - currentX;
      const threshold = 50;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      } else {
        this.updateSlider();
      }
    });
    
    // Mouse events para desktop
    this.sliderTrack.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isDragging = true;
      this.sliderTrack.style.transition = 'none';
      e.preventDefault();
    });
    
    this.sliderTrack.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      currentX = e.clientX;
      const diff = startX - currentX;
      this.sliderTrack.style.transform = `translateX(${-this.currentIndex * (100 / this.slidesToShow)}% - ${diff}px)`;
    });
    
    this.sliderTrack.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      this.sliderTrack.style.transition = 'transform 0.3s ease';
      
      const diff = startX - currentX;
      const threshold = 50;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.next();
        } else {
          this.prev();
        }
      } else {
        this.updateSlider();
      }
    });
    
    this.sliderTrack.addEventListener('mouseleave', () => {
      if (isDragging) {
        isDragging = false;
        this.sliderTrack.style.transition = 'transform 0.3s ease';
        this.updateSlider();
      }
    });
  }
  
  createPagination() {
    this.paginationContainer = document.createElement('div');
    this.paginationContainer.className = 'reviews-pagination';
    
    const totalPages = Math.ceil(this.totalSlides / this.slidesToMove);
    
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('button');
      dot.className = 'fcd-media-dots';
      dot.setAttribute('data-index', i);
      dot.addEventListener('click', () => this.goToSlide(i));
      this.paginationContainer.appendChild(dot);
    }
    
    this.sliderContainer.appendChild(this.paginationContainer);
    this.updatePagination();
  }
  
  updatePagination() {
    const dots = this.paginationContainer.querySelectorAll('.fcd-media-dots');
    const currentPage = Math.floor(this.currentIndex / this.slidesToMove);
    
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentPage);
    });
  }
  
  next() {
    const maxIndex = this.totalSlides - this.slidesToShow;
    if (this.currentIndex < maxIndex) {
      this.currentIndex = Math.min(this.currentIndex + this.slidesToMove, maxIndex);
      this.updateSlider();
      this.updatePagination();
    }
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex = Math.max(this.currentIndex - this.slidesToMove, 0);
      this.updateSlider();
      this.updatePagination();
    }
  }
  
  goToSlide(index) {
    this.currentIndex = index * this.slidesToMove;
    this.updateSlider();
    this.updatePagination();
  }
  
  updateSlider() {
    const translateX = -(this.currentIndex * (100 / this.slidesToShow));
    this.sliderTrack.style.transform = `translateX(${translateX}%)`;
  }
}

// Inicializar sliders cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  const reviewBlocks = document.querySelectorAll('.fcd-reviews-block');
  reviewBlocks.forEach(block => {
    new ReviewsSlider(block);
  });
});

// Re-inicializar si se cargan dinámicamente
window.addEventListener('load', function() {
  const reviewBlocks = document.querySelectorAll('.fcd-reviews-block');
  reviewBlocks.forEach(block => {
    if (!block.querySelector('.reviews-slider-container')) {
      new ReviewsSlider(block);
    }
  });
});
